import React from 'react';
import { nl2br } from '../../../../Helpers/nl2br.helper';
// @ts-ignore
import styles from './PatientMedicalHistoryItem.module.scss';
import { MedicalHistoryItem } from '../../Hooks/usePatientMedicalHistory';

interface Props {
	item: MedicalHistoryItem;
}

const PatientMedicalHistoryItem: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.item}>
			<div className={styles.head}>
				<div className={styles.title}>{item.title}</div>
			</div>
			<div>{nl2br(item.value)}</div>
		</div>
	);
};

export default PatientMedicalHistoryItem;
